var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextStory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 886 347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.181-.71c-.101 0-.158.057-.158.157v.015c0 .082.033.14.13.222.071.06.092.095.092.139v.023c0 .044-.02.066-.06.066-.04 0-.06-.022-.06-.066v-.05l-.102.01v.047c0 .1.059.157.164.157.105 0 .164-.057.164-.157v-.035c0-.084-.036-.142-.133-.224C.147-.466.129-.501.129-.542v-.009c0-.04.019-.061.054-.061s.054.021.054.061v.026l.102-.01v-.018c0-.1-.057-.157-.158-.157z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 64.023 0) translate(748.8 1161.7) scale(88.4358)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.343-.7H.011v.1h.113V0H.23v-.6h.113v-.1z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 64.023 0) translate(780.26 1161.7) scale(88.4358)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.217-.71c-.106 0-.171.067-.171.177v.366c0 .11.065.177.171.177.106 0 .171-.067.171-.177v-.366c0-.11-.065-.177-.171-.177zm0 .098c.042 0 .065.028.065.08v.364c0 .052-.023.08-.065.08S.152-.116.152-.168v-.364c0-.052.023-.08.065-.08z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 64.023 0) translate(811.173 1161.7) scale(88.4358)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.408 0L.311-.319c.049-.028.075-.08.075-.154v-.05C.386-.638.324-.7.21-.7H.057V0h.106v-.296h.049L.296 0h.112zM.206-.602c.051 0 .074.027.074.086v.036c0 .059-.023.086-.074.086H.163v-.208h.043z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 71.893 0) translate(840.845 1161.7) scale(88.4358)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.387-.7h-.11l-.085.248H.19L.101-.7h-.112l.147.383V0h.106v-.316L.387-.7z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 71.893 0) translate(876.801 1161.7) scale(88.4358)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.181-.71c-.101 0-.158.057-.158.157v.015c0 .082.033.14.13.222.071.06.092.095.092.139v.023c0 .044-.02.066-.06.066-.04 0-.06-.022-.06-.066v-.05l-.102.01v.047c0 .1.059.157.164.157.105 0 .164-.057.164-.157v-.035c0-.084-.036-.142-.133-.224C.147-.466.129-.501.129-.542v-.009c0-.04.019-.061.054-.061s.054.021.054.061v.026l.102-.01v-.018c0-.1-.057-.157-.158-.157z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 63.864 0) translate(746.94 1161.7) scale(88.4358)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.343-.7H.011v.1h.113V0H.23v-.6h.113v-.1z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 63.864 0) translate(778.4 1161.7) scale(88.4358)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.217-.71c-.106 0-.171.067-.171.177v.366c0 .11.065.177.171.177.106 0 .171-.067.171-.177v-.366c0-.11-.065-.177-.171-.177zm0 .098c.042 0 .065.028.065.08v.364c0 .052-.023.08-.065.08S.152-.116.152-.168v-.364c0-.052.023-.08.065-.08z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 63.864 0) translate(809.313 1161.7) scale(88.4358)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.408 0L.311-.319c.049-.028.075-.08.075-.154v-.05C.386-.638.324-.7.21-.7H.057V0h.106v-.296h.049L.296 0h.112zM.206-.602c.051 0 .074.027.074.086v.036c0 .059-.023.086-.074.086H.163v-.208h.043z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 71.734 0) translate(838.985 1161.7) scale(88.4358)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.387-.7h-.11l-.085.248H.19L.101-.7h-.112l.147.383V0h.106v-.316L.387-.7z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 71.734 0) translate(874.941 1161.7) scale(88.4358)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.181-.71c-.101 0-.158.057-.158.157v.015c0 .082.033.14.13.222.071.06.092.095.092.139v.023c0 .044-.02.066-.06.066-.04 0-.06-.022-.06-.066v-.05l-.102.01v.047c0 .1.059.157.164.157.105 0 .164-.057.164-.157v-.035c0-.084-.036-.142-.133-.224C.147-.466.129-.501.129-.542v-.009c0-.04.019-.061.054-.061s.054.021.054.061v.026l.102-.01v-.018c0-.1-.057-.157-.158-.157z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 63.94 0) translate(747.83 1161.7) scale(88.4358)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.343-.7H.011v.1h.113V0H.23v-.6h.113v-.1z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 63.94 0) translate(779.29 1161.7) scale(88.4358)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.217-.71c-.106 0-.171.067-.171.177v.366c0 .11.065.177.171.177.106 0 .171-.067.171-.177v-.366c0-.11-.065-.177-.171-.177zm0 .098c.042 0 .065.028.065.08v.364c0 .052-.023.08-.065.08S.152-.116.152-.168v-.364c0-.052.023-.08.065-.08z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 63.94 0) translate(810.203 1161.7) scale(88.4358)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.408 0L.311-.319c.049-.028.075-.08.075-.154v-.05C.386-.638.324-.7.21-.7H.057V0h.106v-.296h.049L.296 0h.112zM.206-.602c.051 0 .074.027.074.086v.036c0 .059-.023.086-.074.086H.163v-.208h.043z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 71.81 0) translate(839.875 1161.7) scale(88.4358)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.387-.7h-.11l-.085.248H.19L.101-.7h-.112l.147.383V0h.106v-.316L.387-.7z",
    transform: "translate(-3018.21 -4541.02) scale(4.16667) matrix(.9145 0 0 1 71.81 0) translate(875.83 1161.7) scale(88.4358)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M355.504 0H382.82500000000005V19.067H355.504z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M364.983 219.804H381.375V249.854H364.983z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M508.787 70.113H523.345V84.67099999999999H508.787z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M0 111.654H17.758V129.417H0z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M836.879 143.621H847.7040000000001V149.083H836.879z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M786.154 13.975H816.066V30.366999999999997H786.154z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M284.471 0H355.504V19.067H284.471z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M847.704 143.621H885.954V149.083H847.704z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M850.854 249.233H880.908V271.091H850.854z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M816.063 13.975H824.259V30.366999999999997H816.063z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M156.967 319.067H197.94600000000003V346.38800000000003H156.967z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M469.15 63.75H501.933V76.479H469.15z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M598.6 289.9H664.171V303.558H598.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextStory);
export default __webpack_public_path__ + "static/media/text-story.9f75ee31e3aa1683f3211e7b15296a16.svg";
export { ForwardRef as ReactComponent };